<app-preloader></app-preloader>
<app-navbar *ngIf="!(location == '/coming-soon')" [location]="location"></app-navbar>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!(location == '/coming-soon')"></app-footer>
<app-cookie-consent></app-cookie-consent>